// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"activityactions_disable-scroll__6A6tK"};